import { render } from "./PdfLearningViewer.vue?vue&type=template&id=6459539a&scoped=true"
import script from "./PdfLearningViewer.vue?vue&type=script&lang=js"
export * from "./PdfLearningViewer.vue?vue&type=script&lang=js"

import "./PdfLearningViewer.vue?vue&type=style&index=0&id=6459539a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6459539a"]])

export default __exports__